import styles from './SquareItem.module.scss';

import cx from 'classnames';
import React, { FC, useRef, useState } from 'react';

import { Card, ICardProps } from 'components/Card/Card';
import { pauseEnhancedMedia, playEnhancedMedia } from 'components/CarouselModule/utils';
import type { EnhancedMedia } from 'components/EnhancedMedia/EnhancedMedia';
import { isEntry } from 'utils/EntryUtil';
import { ContentLink } from 'components/ContentLink/ContentLink';
import { TextWithArrow } from 'components/TextWithArrow/TextWithArrow';
import { TextV2 } from 'components/TextV2/TextV2';
import { RichBlurb } from 'components/RichBlurb/RichBlurb';

export const SquareItem: FC<ICardProps & { noImage?: boolean }> = ({
  entry,
  tabIndex,
  className,
  carouselType,
  noImage,
  ...props
}) => {
  const enhancedMedia = useRef<EnhancedMedia>(null);
  const [hovered, setHovered] = useState(false);

  if (!isEntry(entry)) return null;

  const { link, blurb, title, richBlurb } = entry.fields;

  const onHover = (isHover: boolean) => {
    if (isHover) {
      playEnhancedMedia(enhancedMedia.current);
    } else {
      pauseEnhancedMedia(enhancedMedia.current);
    }
    setHovered(isHover);
  };

  return (
    <div
      className={cx(styles.squareItem, className, hovered && styles.hovered, noImage && styles.noImage)}
      onMouseEnter={() => onHover(true)}
      onMouseLeave={() => onHover(false)}
    >
      <Card
        entry={entry}
        mediaClassName={styles.mediaWrapper}
        captionClassName={styles.cardCaption}
        enhancedMediaRef={enhancedMedia}
        mediaProps={{
          muted: true,
          autoPlay: false,
        }}
        className="square-card"
        {...props}
      >
        {link || blurb || title || richBlurb ? (
          <div className={styles.content}>
            {link ? (
              <ContentLink
                alwaysRenderChildren
                className={styles.link}
                entry={entry.fields.link}
                hideTitle
                tabIndex={tabIndex}
              >
                <TextWithArrow
                  size="x-large"
                  className={styles.textWithArrow}
                  iconClassName={styles.arrowIcon}
                >
                  {link.fields?.title || title}
                </TextWithArrow>
              </ContentLink>
            ) : (
              <TextV2 variant="modern-h4" className={styles.title} value={title} />
            )}
            <TextV2 variant="modern-body" className={styles.blurb} value={blurb} isMarkdown />
            <RichBlurb className={styles.blurb} document={richBlurb} />
          </div>
        ) : null}
      </Card>
    </div>
  );
};
